import { createSlice } from "@reduxjs/toolkit";
import type { MeasureDatasetsActionTypes, MeasureDatasetsState } from "../types/measureDatasetsState.types";
import { MEASURE_DATASETS_SLICE_NAME } from "../utils/storeUtils";

const initialState: MeasureDatasetsState = {
  datasets: [],
  loaded: false,
  loading: false,
};

export const measureDatasetsSlice = createSlice({
  name: MEASURE_DATASETS_SLICE_NAME,
  initialState,
  reducers: {
    update: (state, action: MeasureDatasetsActionTypes["update"]) => {
      Object.assign(state, action.payload);
    },
  },
});

export default measureDatasetsSlice.reducer;
